"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperAddress = exports.validateAddress = void 0;
const constant_1 = require("../constant");
const order_1 = require("../types/order");
const common_1 = require("./common");
const zipcode_1 = require("./zipcode");
const validateAddress = async (address, paymentType = order_1.ADDRESS_PAYMENT_METHODS.ALL, { resolve }) => {
    const { firstName, city, phone, pinCode, address: streetAddress, } = address || {};
    const error = {};
    const isValidPinCode = await (0, zipcode_1.validateZipCode)(pinCode, paymentType, resolve);
    if (!phone || !constant_1.PHONE_REGEX.test((0, common_1.removePhonePrefix)(phone))) {
        error.phone = "Please enter valid phone number";
    }
    if (!isValidPinCode) {
        if (!pinCode || paymentType === order_1.ADDRESS_PAYMENT_METHODS.ALL) {
            error.pincode = "Please enter valid pincode";
        }
        else if (paymentType === order_1.ADDRESS_PAYMENT_METHODS.PREPAID) {
            error.pincode = "Online Delivery is not available at this pincocde";
        }
        else {
            error.pincode = "Cash on Delivery is not available at this pincocde";
        }
    }
    if (!firstName) {
        error.firstname = "Please enter firstname";
    }
    if (!streetAddress) {
        error.address = "Please enter address";
    }
    if (!city) {
        error.city = "Please enter city";
    }
    if (Object.keys(error).length > 0) {
        return error;
    }
    else {
        return null;
    }
};
exports.validateAddress = validateAddress;
const getProperAddress = (address) => {
    const tempAddress = Object.assign(Object.assign({}, address), { country: "IN", phone: (0, common_1.addPhonePrefix)(address === null || address === void 0 ? void 0 : address.phone) });
    if (address.firstName || address.lastName) {
        tempAddress.name = address.firstName + " " + address.lastName;
        delete tempAddress.firstName;
        delete tempAddress.lastName;
    }
    if (!address.email) {
        delete tempAddress.email;
    }
    return tempAddress;
};
exports.getProperAddress = getProperAddress;
